import { Input, Directive } from '@angular/core';

@Directive()
export abstract class SpecificComponent<T>
{
    @Input() item: T;
}
